import React from 'react';
import { useGame } from '../context/GameContext';
import { BookOpen, CheckCircle } from 'lucide-react';

// Sample Data
const CARDS_DATA = [
  { id: 101, term: "SELECT", def: "Retrieves data from a database." },
  { id: 102, term: "WHERE", def: "Filters records based on a condition." },
  { id: 103, term: "JOIN", def: "Combines rows from two or more tables." },
  { id: 104, term: "INDEX", def: "Improves the speed of data retrieval." },
];

const FlipCardsPage = () => {
  const { flippedCards, setFlippedCards, setBalance, addXp } = useGame();
  
  // Safety checks
  const myFlippedCards = flippedCards || [];

  const handleCardClick = (id) => {
    if (myFlippedCards.includes(id)) return;
    setFlippedCards([...myFlippedCards, id]);
    setBalance((prev) => prev + 100); 
    addXp(20, "Card Flip");
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white p-8 pb-20">
      <div className="max-w-4xl mx-auto">
        
        <header className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-emerald-400 flex items-center justify-center gap-3">
            <BookOpen /> Daily SQL Cards
          </h1>
          <p className="text-slate-400 mt-2">Flip cards to learn terms and earn chips!</p>
          <div className="mt-4 inline-block bg-slate-900 px-4 py-2 rounded-full border border-slate-700">
            Progress: {myFlippedCards.length} / {CARDS_DATA.length}
          </div>
        </header>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {CARDS_DATA.map((card) => {
            const isFlipped = myFlippedCards.includes(card.id);

            return (
              <div 
                key={card.id}
                onClick={() => handleCardClick(card.id)}
                className="group h-64 w-full [perspective:1000px] cursor-pointer"
              >
                {/* INNER CONTAINER: Handles the 3D Flip */}
                <div className={`
                  relative h-full w-full transition-all duration-700 [transform-style:preserve-3d]
                  ${isFlipped ? '[transform:rotateY(180deg)]' : ''}
                `}>
                  
                  {/* --- FRONT FACE --- */}
                  <div className="absolute inset-0 h-full w-full [backface-visibility:hidden]">
                    <div className="h-full w-full p-6 flex flex-col items-center justify-center text-center border rounded-xl shadow-lg bg-slate-800 border-slate-600 text-slate-300">
                      <BookOpen className="mb-4 opacity-50" size={32} />
                      <h3 className="text-xl font-bold mb-2 text-white">{card.term}</h3>
                      <div className="mt-2 text-xs text-yellow-500 font-mono border border-yellow-500/30 px-2 py-1 rounded">
                        REWARD: $100
                      </div>
                    </div>
                  </div>

                  {/* --- BACK FACE --- */}
                  {/* Note: [transform:rotateY(180deg)] here fixes the mirroring issue */}
                  <div className="absolute inset-0 h-full w-full [backface-visibility:hidden] [transform:rotateY(180deg)]">
                    <div className="h-full w-full p-6 flex flex-col items-center justify-center text-center border rounded-xl shadow-lg bg-emerald-900/40 border-emerald-500 text-emerald-100">
                      <h3 className="text-xl font-bold mb-2 text-emerald-400">{card.term}</h3>
                      <p className="text-sm leading-relaxed">{card.def}</p>
                      <CheckCircle className="mt-4 text-emerald-500" size={24} />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default FlipCardsPage;